module.exports = __webpack_public_path__ + "img/marker3.59f994f4.webp";